<template>
  <div class="points-match-list">
    <div class="header" v-if="type === 'add'">
      <van-sticky>
        <van-dropdown-menu>
          <van-dropdown-item title="筛选" ref="item">
            <van-tree-select
                :items="items"
                :active-id.sync="activeId"
                :main-active-index.sync="activeIndex"
                @click-item="clickItem"
              />
          </van-dropdown-item>
        </van-dropdown-menu>
      </van-sticky>
    </div>
    <div class="list">
      <div class="item" v-for="item in list" :key="item.gameId">
        <div class="title">{{item.group}} {{item.stageName}} 第{{item.round}}轮</div>
        <div class="content flex-center" @click="item.checked = !item.checked">
          <div v-if="!item.scoreboardId" style="width: 34px;"><van-checkbox v-model="item.checked" ></van-checkbox></div>
          <span v-else class="scoreboard-name">{{ item.scoreboardName }}</span>
          <div class="time" v-if="item.beginDate">
            <div>{{ getFormatDate(item.beginDate, '{m}/{d}') }}</div>
            <div>{{ getFormatDate(item.beginDate, '{h}:{i}') }}</div>
          </div>
          <div class="time" v-else>未设置</div>
          <div class="team">
            <div class="team-info">
              <img :src="imageView(item.homeBadge)" alt="">
              <div class="name">{{ item.homeTeamName }}</div>
            </div>
            <div class="team-info" style="margin-top: 4px;">
              <img :src="imageView(item.awayBadge)" alt="">
              <div class="name">{{ item.awayTeamName }}</div>
            </div>
          </div>
          <div class="score">
            <div>{{ item.homeScore == '-1' ? '-' : item.homeScore }}</div>
            <div>{{ item.awayScore == '-1' ? '-' : item.awayScore }}</div>
          </div>
        </div>
      </div>
      <div class="empty" v-if="list.length === 0">
        <van-empty description="暂无赛事" />
      </div>
    </div>
    <div class="footer">
      <div class="add-btn" v-if="type === 'add'" @click="addScoreboardGames">加入比赛计划</div>
      <div class="add-btn2" v-else @click="removeScoreboardGames">移出比赛计划</div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Checkbox,Dialog,Empty,DropdownMenu, DropdownItem,TreeSelect,Sticky } from 'vant'
Vue.use(Checkbox).use(Dialog).use(Empty).use(DropdownMenu).use(DropdownItem).use(TreeSelect).use(Sticky)
import { adminGetBMUnionMatchGameList2,adminAddScoreboardGames,adminGetScoreboardGames,adminRemoveScoreboardGames,adminGetBMUnionMatchStages } from '@/api/match'
import {DateUtil, QNImageUtil} from '@/utils'
export default {
  data() {
    return {
      list: [],
      unionMatchId: '',
      type: 'add',
      items: [{ text: '全部', value: 0, children: [{text: '全部', id: 0}] }],
      activeId: 0,
      activeIndex: 0,
      filterObj:{}
    };
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.id = this.$route.query.id
    this.type = this.$route.query.type
    if(this.type === 'add') {
      this.adminGetBMUnionMatchGameList2()
      this.adminGetBMUnionMatchStages()
    } else {
      this.adminGetScoreboardGames()
    }
  },
  methods: {
    clickItem(item) {
      if (item.id === 0) {
        this.filterObj = {}
        this.adminGetBMUnionMatchGameList2()
        this.$refs.item.toggle()
        return
      }
      this.filterObj = {
        stageId: item.stageId,
        matchId: item.matchId,
        round: item.round
      }
      this.adminGetBMUnionMatchGameList2()
      this.$refs.item.toggle()
    },
    adminGetBMUnionMatchStages() {
      adminGetBMUnionMatchStages({ unionMatchId: this.unionMatchId }).then(res => {
        const { data } = res
        const matches = data.matches
        matches.forEach(item => {
          this.items.push({
            text: item.group,
            value: item.id,
            children: this.getRoundList(item)
          })
        })
        console.log(this.items,'this.items');
      })
    },
    getRoundList(match) { 
      var rounds = []
      if (match.stages.length >= 1) {
        match.stages.forEach((item) => {
          for (let i = 1; i <= item.roundCount; i++) {
            let label = item.stageName + '第' + i + '轮'
            if (item.roundAliasList) {
              const obj = item.roundAliasList.find(a => a.round === i) || null
              if (obj) {
                label = obj.alias
              }
            }
            rounds.push({
              text: label,
              id: item.id + '_' + i,
              round: i,
              stageId: item.id,
              matchId: match.id
            })
          }
        });
      }
      return rounds
    },
    getDefaultRoundDescription(isGroupRound, round, match) {
      var description = ''

      console.log(match, 'match');
      if (!isGroupRound) {
        if (round > match.knockoutRoundCount) { // 理论上，此时round是不可能大于knockoutRoundCount的
          round = match.knockoutRoundCount// 修正Server端的数据异常，提高容错性。
        }
        if (round === match.knockoutRoundCount) {
          description = '决赛'
        } else if (round === match.knockoutRoundCount - 1) {
          description = '半决赛'
        } else {
          description = '1/' + Math.pow(2, match.knockoutRoundCount - round) + '决赛'
        }
      } else {
        if (round > match.roundCount) { // 理论上，此时round是不可能大于roundCount的
          round = match.roundCount// 修正Server端的数据异常，提高容错性。
        }
        var prefix = match.type === 'cup' ? '小组赛 ' : ''
        description = prefix + '第' + round + '轮'
      }
      return description
    },
    adminGetScoreboardGames() {
      adminGetScoreboardGames({ unionMatchId: this.unionMatchId, id: this.id }).then(res => {
        const { data } = res
        this.list = data.list.map(item => {
          return {
            ...item,
            checked: false
          }
        })
      })
    },
    removeScoreboardGames() {
      Dialog.confirm({
        title: '提示',
        message: '确定要移出比赛计划吗？'
      }).then(() => {
        this.removeScoreboardGamesFun()
      })
    },
    removeScoreboardGamesFun() {
      const selectedItems = this.list.filter(item => item.checked && item.gameId)
      if (selectedItems.length === 0) {
        this.$toast('请至少选择一场比赛')
        return
      }
      const params = {
        id: this.id
      }
      const gameIds = selectedItems.map(item => item.gameId)
      params.gameIds = gameIds.join(',')
      adminRemoveScoreboardGames(params).then(res => {
        if (res) {
          this.$toast('移出比赛计划成功')
          this.$router.back()
        }
      })
    },
    adminGetBMUnionMatchGameList2() {
      adminGetBMUnionMatchGameList2({ unionMatchId: this.unionMatchId,sortOrder: 1,noScoreboard: 1,pageSize: 9999,...this.filterObj }).then(res => {
        const { data } = res
        this.list = data.list.map(item => {
          return {
            ...item,
            checked: false
          }
        })
      })
    },
    getFormatDate(date, type) {
      if (!type) type = '{y}-{m}-{d}'
      return DateUtil.parseDateTime(date, type)
    },
    imageView(img, w, h) {
      return QNImageUtil.imageView(img, w, h)
    },
    addScoreboardGames() {
      const params = {
        id: this.id
      }
      // 获取选中的比赛ID列表
      const selectedItems = this.list.filter(item => item.checked && item.gameId)
      
      // 检查是否有选中的项目
      if (selectedItems.length === 0) {
        this.$toast('请至少选择一场比赛')
        return
      }
      const gameIds = selectedItems.map(item => item.gameId)
      params.gameIds = gameIds.join(',')
      adminAddScoreboardGames(params).then(res => {
        if (res) {
          this.$toast('加入比赛计划成功')
          this.$router.back()
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
.points-match-list{
  width: 100%;
  height: 100vh;
  background-color: #F6F6F6;
  // padding-top: 10px;
  padding-bottom: 100px;
  box-sizing: border-box;
  overflow-y: auto;
  .header{
    margin-bottom: 10px;
  }
  .list{
    .item{
      background-color: #fff;
      margin-bottom: 10px;
      .content{
        padding: 0 18px;
        height: 75px;
        .scoreboard-name{
          width: 34px;
          font-size: 12px;
          text-align: center;
          color: #9E9E9E;
        }
      }
      .title{
        background: linear-gradient(90deg, #FFEECD 2%, #FFFFFF 104%);
        font-size: 12px;
        color: #5E5E5E;
        height: 22px;
        line-height: 22px;
        padding: 0 13px;
        box-sizing: border-box;
      }
      .time{
        font-size: 12px;
        color: #666666;
        margin: 0 32px;
      }
      .team{
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .team-info{
          display: flex;
          align-items: center;
          height: 30px;
          img{
            width: 30px;
            height: 30px;
            margin-right: 4px;
            border-radius: 50%;
          }
          .name{
            font-size: 13px;
            color: #3D3D3D;
          }
        }
      }
      .score{
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 15px;
        font-weight: bold;
        color: #3D3D3D;
        div{
          height: 30px;
          line-height: 30px;
          padding-right: 20px;
          text-align: right;
        }
      }
    }
  }
  .footer{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 0 15px;
    padding-bottom: 34px;
    padding-top: 10px;
    box-sizing: border-box;
    display: flex;
    justify-content: flex-end;
    .add-btn{
      width: 132px;
      height: 45px;
      border-radius: 5px;
      background-color:#337ECC;
      font-size: 15px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      line-height: 45px;
    }
    .add-btn2{
      width: 132px;
      height: 45px;
      border-radius: 5px;
      background-color: #C45656;
      font-size: 15px;
      font-weight: 500;
      color: #FFFFFF;
      text-align: center;
      line-height: 45px;
    }
  }
}
</style>
